import { render, staticRenderFns } from "./UnsentCurriculums.vue?vue&type=template&id=51d38b2a&lang=pug"
import script from "./UnsentCurriculums.vue?vue&type=script&lang=js"
export * from "./UnsentCurriculums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports